<!--<app-page>
  <div class="grid grid-rows-2 grid-cols-2 gap-10" body>

    <div class="border rounded-xl p-5">
      <h5 class="font-semibold">New Cards</h5>
      <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
    </div>

    <div class="border rounded-xl p-5">
      <h5 class="font-semibold">Renew Cards</h5>
      <p-chart type="line" [data]="basicData" [options]="options"></p-chart>
    </div>
  </div>
</app-page>-->
<app-page>
  <div body>
    <h3 class="mb-5">{{ greetingText }}, {{ userName }}</h3>
<!-- Notification Dialog -->

<!--<p-dialog header="New" [(visible)]="displayDialog" [modal]="true" [closable]="true">-->
<!--  &lt;!&ndash; <ng-container *ngIf="notifications.length > 0; else noNotifications">-->
<!--    <ul>-->
<!--      <li *ngFor="let notification of notifications">-->
<!--        <strong>{{ notification.title }}</strong>-->
<!--        <div [innerHTML]="notification.message"></div>-->
<!--        <div > Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quibusdam molestiae ullam, modi debitis nam quam labore, laborum nisi, a atque sunt dignissimos nobis pariatur ipsam porro corrupti consequuntur commodi eaque.</div>-->
<!--        <small>{{ notification.createdAt | date:'medium' }}</small>-->
<!--        <small>{{ "2025-02-06T16:25:39.674868" | date:'medium' }}</small>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </ng-container> &ndash;&gt;-->
<!--  <p>New Account Type Added.</p>-->
<!--  &lt;!&ndash; <img src="https://i.ibb.co/bpVMBV9/CCMS-Logo.png" alt=""> &ndash;&gt;-->
<!--  <img src="assets/images/CardCentralLogo.png" alt="">-->
<!--  <small>Created at: {{ "2025-02-06T16:25:39.674868" | date:'medium' }}</small>-->
<!--  <ng-template #noNotifications>-->
<!--    <p>No notifications available.</p>-->
<!--  </ng-template>-->
<!--  <p-footer>-->
<!--    <button type="button" (click)="closeDialog()">Close</button>-->
<!--  </p-footer>-->
<!--</p-dialog>-->
    <hr class="m-4" />

    <!-- STAT BOX ! -->


    <div class="mb-12 grid gap-y-10 gap-x-6 md:grid-cols-2 xl:grid-cols-4">
      <div
      class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"

      >
        <div
          class="bg-clip-border mt-4 mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-gray-900/20 absolute grid h-12 w-12 place-items-center"
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            class="w-6 h-6 text-white"
          >
            <path d="M12 7.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"></path>
            <path
              fill-rule="evenodd"
              d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 14.625v-9.75zM8.25 9.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM18.75 9a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-.008zM4.5 9.75A.75.75 0 015.25 9h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V9.75z"
              clip-rule="evenodd"
            ></path>
            <path
              d="M2.25 18a.75.75 0 000 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 00-.75-.75H2.25z"
            ></path>
          </svg> -->

          <!-- <img  src="assets/images/card-add.svg" class="w-[300px]"/> -->
          <svg style="width: 100%; height: 100%;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            data-locator-target="vscode://file${projectPath}${filePath}:${line}:${column}"
            data-locator-experimental-features="true">
            <path opacity="0.4" style="fill: var(--secondary);"
              d="M22 7.77039V9.00039H2V7.54039C2 5.25039 3.86 3.40039 6.15 3.40039H16V5.97039C16 7.24039 16.76 8.00039 18.03 8.00039H20.97C21.37 8.00039 21.71 7.93039 22 7.77039Z"
              fill="#e5a812" />
            <path style="fill: var(--secondary);"
              d="M2 9V16.46C2 18.75 3.86 20.6 6.15 20.6H17.85C20.14 20.6 22 18.75 22 16.46V9H2ZM8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25ZM14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
              fill="#e5a812" />
            <path style="fill: var(--primary);"
              d="M20.97 1H18.03C16.76 1 16 1.76 16 3.03V5.97C16 7.24 16.76 8 18.03 8H20.97C22.24 8 23 7.24 23 5.97V3.03C23 1.76 22.24 1 20.97 1ZM21.91 4.93C21.81 5.03 21.66 5.1 21.5 5.11H20.09L20.1 6.5C20.09 6.67 20.03 6.81 19.91 6.93C19.81 7.03 19.66 7.1 19.5 7.1C19.17 7.1 18.9 6.83 18.9 6.5V5.1L17.5 5.11C17.17 5.11 16.9 4.83 16.9 4.5C16.9 4.17 17.17 3.9 17.5 3.9L18.9 3.91V2.51C18.9 2.18 19.17 1.9 19.5 1.9C19.83 1.9 20.1 2.18 20.1 2.51L20.09 3.9H21.5C21.83 3.9 22.1 4.17 22.1 4.5C22.09 4.67 22.02 4.81 21.91 4.93Z"
              fill="#e5a812" />
          </svg>

        </div>
        <div class="p-4 text-right">
          <p
            class="block antialiased font-sans text-md leading-normal font-normal text-blue-gray-600"
          >
           NEW CARDS
          </p>
          <h4
            class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"
          >

            {{getCountByCardGenType('NEW')}}
          </h4>
        </div>
        <div class="border-t border-blue-gray-50 p-4">
          <p
            class="block antialiased font-sans text-base leading-relaxed font-normal text-blue-gray-600"
          >
            <!--<strong class="text-green-500 text-xl">+55%</strong>&nbsp;than last month-->
           <!-- <strong class="text-green-500 text-xl">{{ getChangePercentage('NEW') }}</strong>&nbsp;than last month-->
            <!--<strong [innerHTML]="getChangePercentage('NEW')" class="text-xl"></strong>&nbsp;than last month-->
            <strong [innerHTML]="getChangePercentageForCardGenType('NEW')" class="text-xl"></strong>&nbsp;than last month


          </p>
        </div>
      </div>
      <div
        class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"
      >
        <div
          class="bg-clip-border mt-4 mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-gray-900/20 absolute grid h-12 w-12 place-items-center"
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            class="w-6 h-6 text-white"
          >
            <path
              d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z"
            ></path>
          </svg> -->
          <!-- <img  src="assets/images/card-renewed.svg" class="w-[300px]"/> -->

          <svg style="width: 100%; height: 100%;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            data-locator-target="vscode://file${projectPath}${filePath}:${line}:${column}"
            data-locator-experimental-features="true">
            <path opacity="0.4" style="fill: var(--secondary);"
              d="M22 7.77039V9.00039H2V7.54039C2 5.25039 3.86 3.40039 6.15 3.40039H16V5.97039C16 7.24039 16.76 8.00039 18.03 8.00039H20.97C21.37 8.00039 21.71 7.93039 22 7.77039Z"
              fill="#fff" />
            <path style="fill: var(--secondary);"
              d="M2 9V16.46C2 18.75 3.86 20.6 6.15 20.6H17.85C20.14 20.6 22 18.75 22 16.46V9H2ZM8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25ZM14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
              fill="#e5a812" />
            <path style="fill: var(--primary);"
              d="M18.03 1H20.97C22.24 1 23 1.76 23 3.03V5.97C23 7.24 22.24 8 20.97 8H18.03C16.76 8 16 7.24 16 5.97V3.03C16 1.76 16.76 1 18.03 1Z"
              fill="#e5a812" />
            <path style="fill: white"
              d="M21.3192 6.08142C21.295 6.12977 21.2628 6.18617 21.2225 6.22646L20.5698 6.87109C20.4892 6.95973 20.3764 7 20.2636 7C20.1426 7 20.03 6.95973 19.9493 6.87109C19.8042 6.73411 19.7881 6.51652 19.8768 6.35537H18.0556C17.4751 6.35537 17 5.87991 17 5.2917V5.20307C17 4.95328 17.2013 4.75989 17.4432 4.75989C17.6851 4.75989 17.8864 4.95328 17.8864 5.20307V5.2917C17.8864 5.38839 17.9589 5.469 18.0556 5.469H19.8768C19.7881 5.29979 19.8042 5.09025 19.9493 4.94521C20.1187 4.77599 20.4005 4.77599 20.5698 4.94521L21.2225 5.59791C21.2628 5.6382 21.295 5.68654 21.3192 5.74295C21.3595 5.8477 21.3595 5.96861 21.3192 6.08142ZM21.3515 3.80098C21.3515 4.05077 21.1502 4.24416 20.9083 4.24416C20.6664 4.24416 20.465 4.05077 20.465 3.80098V3.71235C20.465 3.61566 20.3926 3.53505 20.2958 3.53505H18.4747C18.5634 3.70426 18.5473 3.9138 18.4021 4.05884C18.3215 4.13942 18.2088 4.18775 18.0879 4.18775C17.975 4.18775 17.8623 4.13942 17.7817 4.05884L17.129 3.40614C17.0886 3.36585 17.0565 3.3175 17.0323 3.2611C16.9919 3.15635 16.9919 3.03543 17.0323 2.92263C17.0565 2.87428 17.0886 2.81788 17.129 2.77759L17.7817 2.13295C17.951 1.95568 18.2328 1.95568 18.4021 2.13295C18.5473 2.26993 18.5634 2.48752 18.4747 2.64868H20.2958C20.8764 2.64868 21.3515 3.12413 21.3515 3.71235V3.80098Z"
              fill="white" />
          </svg>

          <!-- <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M55.9193 2.66699H48.0793C44.6927 2.66699 42.666 4.69366 42.666 8.08033V15.9203C42.666 19.307 44.6927 21.3337 48.0793 21.3337H55.9193C59.306 21.3337 61.3327 19.307 61.3327 15.9203V8.08033C61.3327 4.69366 59.306 2.66699 55.9193 2.66699ZM56.506 11.4937C56.186 11.8137 55.7593 11.9737 55.3327 11.9737C54.906 11.9737 54.4793 11.8137 54.1593 11.4937L53.6793 11.0137V16.987C53.6793 17.9203 52.9327 18.667 51.9993 18.667C51.066 18.667 50.3194 17.9203 50.3194 16.987V11.0137L49.8393 11.4937C49.1993 12.1337 48.1327 12.1337 47.4927 11.4937C46.8527 10.8537 46.8527 9.78699 47.4927 9.14699L50.826 5.81366C50.9593 5.68033 51.146 5.57366 51.3327 5.49366C51.386 5.46699 51.4393 5.46699 51.4927 5.44033C51.626 5.38699 51.7593 5.36033 51.9193 5.36033C51.9727 5.36033 52.026 5.36033 52.0793 5.36033C52.266 5.36033 52.426 5.38699 52.6127 5.46699C52.6393 5.46699 52.6393 5.46699 52.666 5.46699C52.8527 5.54699 53.0127 5.65366 53.146 5.78699C53.1727 5.81366 53.1727 5.81366 53.1993 5.81366L56.5327 9.14699C57.1727 9.78699 57.1727 10.8537 56.506 11.4937Z" fill="#FED131"/>
            <path opacity="0.4" d="M58.6673 20.7197V23.9997H5.33398V20.1064C5.33398 13.9997 10.294 9.06641 16.4007 9.06641H42.6673V15.9197C42.6673 19.3064 44.694 21.3331 48.0807 21.3331H55.9207C56.9873 21.3331 57.894 21.1464 58.6673 20.7197Z" fill="#FED131"/>
            <path d="M5.33398 24V43.8933C5.33398 50 10.294 54.9333 16.4007 54.9333H47.6007C53.7073 54.9333 58.6673 50 58.6673 43.8933V24H5.33398ZM21.334 46H16.0007C14.9073 46 14.0007 45.0933 14.0007 44C14.0007 42.9067 14.9073 42 16.0007 42H21.334C22.4273 42 23.334 42.9067 23.334 44C23.334 45.0933 22.4273 46 21.334 46ZM38.6673 46H28.0007C26.9073 46 26.0007 45.0933 26.0007 44C26.0007 42.9067 26.9073 42 28.0007 42H38.6673C39.7607 42 40.6673 42.9067 40.6673 44C40.6673 45.0933 39.7607 46 38.6673 46Z" fill="#FED131"/>
            </svg> -->
        </div>
        <div class="p-4 text-right">
          <p
          class="block antialiased font-sans text-md leading-normal font-normal text-blue-gray-600"
          >
            RENEWED CARDS
          </p>
          <h4
            class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"
          >
            {{getCountByCardGenType('RENEW')}}

          </h4>
        </div>
        <div class="border-t border-blue-gray-50 p-4">
          <p
            class="block antialiased font-sans text-base leading-relaxed font-normal text-blue-gray-600"
          >
            <strong [innerHTML]="getChangePercentageForCardGenType('RENEW')" class="text-xl"></strong>&nbsp;than last month
           <!-- <strong class="text-green-500 text-xl">{{ getChangePercentage('RENEW') }}</strong>&nbsp;than last month-->
          </p>
        </div>
      </div>
      <div
        class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"
      >
        <div
          class="bg-clip-border mt-4 mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-gray-900/20 absolute grid h-12 w-12 place-items-center"
        >

        <!-- <img  src="assets/images/card-replaced.svg" class="w-[300px]"/> -->
<svg style="width: 100%; height: 100%;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
  data-locator-target="vscode://file${projectPath}${filePath}:${line}:${column}"
  data-locator-experimental-features="true">
  <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" style="fill: var(--primary);"
    d="M22 14.25C22.4142 14.25 22.75 14.5858 22.75 15C22.75 19.2842 19.2842 22.75 15 22.75C14.7298 22.75 14.4805 22.6047 14.3474 22.3695C14.2142 22.1344 14.2179 21.8458 14.3569 21.6141L15.4069 19.8641C15.62 19.5089 16.0807 19.3938 16.4359 19.6069C16.791 19.82 16.9062 20.2807 16.6931 20.6359L16.4218 21.0881C19.1909 20.4456 21.25 17.9666 21.25 15C21.25 14.5858 21.5858 14.25 22 14.25Z"
    fill="#e5a812 " />
  <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" style="fill: var(--primary);"
    d="M7.57821 2.91194C4.8091 3.55436 2.75 6.03342 2.75 9C2.75 9.41421 2.41421 9.75 2 9.75C1.58579 9.75 1.25 9.41421 1.25 9C1.25 4.71579 4.71579 1.25 9 1.25C9.2702 1.25 9.51952 1.39534 9.65265 1.63047C9.78578 1.8656 9.78214 2.15417 9.64312 2.38587L8.59313 4.13587C8.38002 4.49105 7.91933 4.60623 7.56414 4.39312C7.20896 4.18001 7.09378 3.71932 7.30689 3.36413L7.57821 2.91194Z"
    fill="#e5a812 " />
  <path style="fill: var(--secondary);" opacity="0.4" d="M12 15.7V16.31H2V15.7C2 13.94 2.44 13.5 4.22 13.5H9.78C11.56 13.5 12 13.94 12 15.7Z"
    fill="#e5a812 " />
  <path style="fill: var(--secondary);"
    d="M2 16.3096V17.8096V19.7996C2 21.5596 2.44 21.9996 4.22 21.9996H9.78C11.56 21.9996 12 21.5596 12 19.7996V17.8096V16.3096H2Z"
    fill="#e5a812 " />
  <path style="fill: var(--secondary);" opacity="0.4" d="M22 4.2V4.81H12V4.2C12 2.44 12.44 2 14.22 2H19.78C21.56 2 22 2.44 22 4.2Z" fill="#e5a812 " />
  <path style="fill: var(--secondary);"
    d="M12 4.80957V6.30957V8.29957C12 10.0596 12.44 10.4996 14.22 10.4996H19.78C21.56 10.4996 22 10.0596 22 8.29957V6.30957V4.80957H12Z"
    fill="#e5a812 " />
</svg>

          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            class="w-6 h-6 text-white"
          >
            <path
              d="M6.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM3.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM19.75 7.5a.75.75 0 00-1.5 0v2.25H16a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H22a.75.75 0 000-1.5h-2.25V7.5z"
            ></path>
          </svg> -->
        </div>
        <div class="p-4 text-right">
          <p
            class="block antialiased font-sans text-md leading-normal font-normal text-blue-gray-600"
          >
           REPLACED CARDS
          </p>
          <h4
            class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"
          >
            {{getCountByCardGenType('REPLACE')}}
          </h4>
        </div>
        <div class="border-t border-blue-gray-50 p-4">
          <p
            class="block antialiased font-sans text-base leading-relaxed font-normal text-blue-gray-600"
          >
            <!--<strong class="text-red-500 text-xl">{{ getChangePercentage('REPLACE') }}</strong>&nbsp;than last month-->
            <strong [innerHTML]="getChangePercentageForCardGenType('REPLACE')" class="text-xl"></strong>&nbsp;than last month
          </p>
        </div>
      </div>
      <div
        class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"
      >
        <div
          class="bg-clip-border mt-4 mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-gray-900/20 absolute grid h-12 w-12 place-items-center"
        >

        <!-- <img  src="assets/images/card-send.svg" class="w-[300px]"/> -->
<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" style="width: 100%; height: 100%;"
  data-locator-target="vscode://file${projectPath}${filePath}:${line}:${column}"
  data-locator-experimental-features="true">
  <path style="fill: var(--primary);"
    d="M55.9193 2.66699H48.0793C44.6927 2.66699 42.666 4.69366 42.666 8.08033V15.9203C42.666 19.307 44.6927 21.3337 48.0793 21.3337H55.9193C59.306 21.3337 61.3327 19.307 61.3327 15.9203V8.08033C61.3327 4.69366 59.306 2.66699 55.9193 2.66699ZM56.506 11.4937C56.186 11.8137 55.7593 11.9737 55.3327 11.9737C54.906 11.9737 54.4793 11.8137 54.1593 11.4937L53.6793 11.0137V16.987C53.6793 17.9203 52.9327 18.667 51.9993 18.667C51.066 18.667 50.3194 17.9203 50.3194 16.987V11.0137L49.8393 11.4937C49.1993 12.1337 48.1327 12.1337 47.4927 11.4937C46.8527 10.8537 46.8527 9.78699 47.4927 9.14699L50.826 5.81366C50.9593 5.68033 51.146 5.57366 51.3327 5.49366C51.386 5.46699 51.4393 5.46699 51.4927 5.44033C51.626 5.38699 51.7593 5.36033 51.9193 5.36033C51.9727 5.36033 52.026 5.36033 52.0793 5.36033C52.266 5.36033 52.426 5.38699 52.6127 5.46699C52.6393 5.46699 52.6393 5.46699 52.666 5.46699C52.8527 5.54699 53.0127 5.65366 53.146 5.78699C53.1727 5.81366 53.1727 5.81366 53.1993 5.81366L56.5327 9.14699C57.1727 9.78699 57.1727 10.8537 56.506 11.4937Z"
    fill="#e5a812" />
  <path opacity="0.4" style="fill: var(--secondary);"
    d="M58.6673 20.7197V23.9997H5.33398V20.1064C5.33398 13.9997 10.294 9.06641 16.4007 9.06641H42.6673V15.9197C42.6673 19.3064 44.694 21.3331 48.0807 21.3331H55.9207C56.9873 21.3331 57.894 21.1464 58.6673 20.7197Z"
    fill="#e5a812" />
  <path style="fill: var(--secondary);"
    d="M5.33398 24V43.8933C5.33398 50 10.294 54.9333 16.4007 54.9333H47.6007C53.7073 54.9333 58.6673 50 58.6673 43.8933V24H5.33398ZM21.334 46H16.0007C14.9073 46 14.0007 45.0933 14.0007 44C14.0007 42.9067 14.9073 42 16.0007 42H21.334C22.4273 42 23.334 42.9067 23.334 44C23.334 45.0933 22.4273 46 21.334 46ZM38.6673 46H28.0007C26.9073 46 26.0007 45.0933 26.0007 44C26.0007 42.9067 26.9073 42 28.0007 42H38.6673C39.7607 42 40.6673 42.9067 40.6673 44C40.6673 45.0933 39.7607 46 38.6673 46Z"
    fill="#e5a812" />
</svg>
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            class="w-6 h-6 text-white"
          >
            <path
              d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z"
            ></path>
          </svg> -->
        </div>
        <div class="p-4 text-right">
          <p
            class="block antialiased font-sans text-md leading-normal font-normal text-blue-gray-600"
          >
            ACTIVE CARDS
          </p>
          <h4
            class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"
          >
            {{ getTotalActiveCardsByCardGenType() }}
          </h4>
        </div>
        <div class="border-t border-blue-gray-50 p-4">
          <p
            class="block antialiased font-sans text-base leading-relaxed font-normal text-blue-gray-600"
          >
<!--
            <strong class="text-green-500 text-xl">+5%</strong>&nbsp;than last month
-->
            <strong [innerHTML]="getChangePercentageActive()" class="text-xl"></strong>&nbsp;than last month
          </p>
        </div>
      </div>
    </div>



    <div
      class="mb-6 grid grid-cols-1 gap-y-12 gap-x-6 md:grid-cols-2 xl:grid-cols-3"
    >
    <!-- <div>-----</div> -->


      <div
        class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"
      >
        <div
          class="relative bg-clip-border mt-4 mx-4 rounded-xl overflow-hidden bg-white text-gray-700"
        >
        <div>
          <!--<h4>Card Type</h4>-->
          <h4>Active Cards</h4>
         </div>
        <!-- <div class="card flex justify-content-center"> -->
          <p-chart type="pie" [data]="piechartData" [options]="pieOptions" width="500" height="260"/>
      <!-- </div> -->
          <!-- <div
            type="bar"
            height="220"
            series="[object Object]"
            options="[object Object]"
            width="100%"
            style="min-height: 235px"
          >
            <div
              id="apexchartsodd6q2q4g"
              class="apexcharts-canvas apexchartsodd6q2q4g apexcharts-theme-light"
              style="width: 502px; height: 220px"
            >
              <svg
                id="SvgjsSvg1752"
                width="502"
                height="220"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.dev"
                class="apexcharts-svg"
                xmlns:data="ApexChartsNS"
                transform="translate(0, 0)"
                style="background: transparent"
              >
                <foreignObject x="0" y="0" width="502" height="220"
                  ><div
                    class="apexcharts-legend"
                    xmlns="http://www.w3.org/1999/xhtml"
                    style="max-height: 110px"
                  ></div
                ></foreignObject>
                <g
                  id="SvgjsG1828"
                  class="apexcharts-yaxis"
                  rel="0"
                  transform="translate(11.609375, 0)"
                >
                  <g id="SvgjsG1829" class="apexcharts-yaxis-texts-g">
                    <text
                      id="SvgjsText1831"
                      font-family="inherit"
                      x="20"
                      y="36.5"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1832">50</tspan>
                      <title>50</title>
                    </text>
                    <text
                      id="SvgjsText1834"
                      font-family="inherit"
                      x="20"
                      y="65.646"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1835">40</tspan>
                      <title>40</title>
                    </text>
                    <text
                      id="SvgjsText1837"
                      font-family="inherit"
                      x="20"
                      y="94.792"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1838">30</tspan>
                      <title>30</title>
                    </text>
                    <text
                      id="SvgjsText1840"
                      font-family="inherit"
                      x="20"
                      y="123.938"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1841">20</tspan>
                      <title>20</title>
                    </text>
                    <text
                      id="SvgjsText1843"
                      font-family="inherit"
                      x="20"
                      y="153.084"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1844">10</tspan>
                      <title>10</title>
                    </text>
                    <text
                      id="SvgjsText1846"
                      font-family="inherit"
                      x="20"
                      y="182.23"
                      text-anchor="end"
                      dominant-baseline="auto"
                      font-size="13px"
                      font-weight="300"
                      fill="#37474f"
                      class="apexcharts-text apexcharts-yaxis-label"
                      style="font-family: inherit"
                    >
                      <tspan id="SvgjsTspan1847">0</tspan>
                      <title>0</title>
                    </text>
                  </g>
                </g>
                <g
                  id="SvgjsG1754"
                  class="apexcharts-inner apexcharts-graphical"
                  transform="translate(41.609375, 35)"
                >
                  <defs id="SvgjsDefs1753">
                    <linearGradient
                      id="SvgjsLinearGradient1757"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        id="SvgjsStop1758"
                        stop-opacity="0.4"
                        stop-color="rgba(216,227,240,0.4)"
                        offset="0"
                      ></stop>
                      <stop
                        id="SvgjsStop1759"
                        stop-opacity="0.5"
                        stop-color="rgba(190,209,230,0.5)"
                        offset="1"
                      ></stop>
                      <stop
                        id="SvgjsStop1760"
                        stop-opacity="0.5"
                        stop-color="rgba(190,209,230,0.5)"
                        offset="1"
                      ></stop>
                    </linearGradient>
                    <clipPath id="gridRectMaskodd6q2q4g">
                      <rect
                        id="SvgjsRect1762"
                        width="444.390625"
                        height="149.73"
                        x="-2"
                        y="-2"
                        rx="0"
                        ry="0"
                        opacity="1"
                        stroke-width="0"
                        stroke="none"
                        stroke-dasharray="0"
                        fill="#fff"
                      ></rect>
                    </clipPath>
                    <clipPath id="forecastMaskodd6q2q4g"></clipPath>
                    <clipPath id="nonForecastMaskodd6q2q4g"></clipPath>
                    <clipPath id="gridRectMarkerMaskodd6q2q4g">
                      <rect
                        id="SvgjsRect1763"
                        width="444.390625"
                        height="149.73"
                        x="-2"
                        y="-2"
                        rx="0"
                        ry="0"
                        opacity="1"
                        stroke-width="0"
                        stroke="none"
                        stroke-dasharray="0"
                        fill="#fff"
                      ></rect>
                    </clipPath>
                  </defs>
                  <rect
                    id="SvgjsRect1761"
                    width="10.066071428571428"
                    height="145.73"
                    x="0"
                    y="0"
                    rx="0"
                    ry="0"
                    opacity="1"
                    stroke-width="0"
                    stroke-dasharray="3"
                    fill="url(#SvgjsLinearGradient1757)"
                    class="apexcharts-xcrosshairs"
                    y2="145.73"
                    filter="none"
                    fill-opacity="0.9"
                  ></rect>
                  <g id="SvgjsG1783" class="apexcharts-grid">
                    <g id="SvgjsG1784" class="apexcharts-gridlines-horizontal">
                      <line
                        id="SvgjsLine1796"
                        x1="0"
                        y1="29.145999999999997"
                        x2="440.390625"
                        y2="29.145999999999997"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1797"
                        x1="0"
                        y1="58.291999999999994"
                        x2="440.390625"
                        y2="58.291999999999994"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1798"
                        x1="0"
                        y1="87.43799999999999"
                        x2="440.390625"
                        y2="87.43799999999999"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1799"
                        x1="0"
                        y1="116.58399999999999"
                        x2="440.390625"
                        y2="116.58399999999999"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                    </g>
                    <g id="SvgjsG1785" class="apexcharts-gridlines-vertical">
                      <line
                        id="SvgjsLine1787"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1788"
                        x1="62.91294642857143"
                        y1="0"
                        x2="62.91294642857143"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1789"
                        x1="125.82589285714286"
                        y1="0"
                        x2="125.82589285714286"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1790"
                        x1="188.73883928571428"
                        y1="0"
                        x2="188.73883928571428"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1791"
                        x1="251.65178571428572"
                        y1="0"
                        x2="251.65178571428572"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1792"
                        x1="314.56473214285717"
                        y1="0"
                        x2="314.56473214285717"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1793"
                        x1="377.4776785714286"
                        y1="0"
                        x2="377.4776785714286"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                      <line
                        id="SvgjsLine1794"
                        x1="440.39062500000006"
                        y1="0"
                        x2="440.39062500000006"
                        y2="145.73"
                        stroke="#dddddd"
                        stroke-dasharray="5"
                        stroke-linecap="butt"
                        class="apexcharts-gridline"
                      ></line>
                    </g>
                    <line
                      id="SvgjsLine1802"
                      x1="0"
                      y1="145.73"
                      x2="440.390625"
                      y2="145.73"
                      stroke="transparent"
                      stroke-dasharray="0"
                      stroke-linecap="butt"
                    ></line>
                    <line
                      id="SvgjsLine1801"
                      x1="0"
                      y1="1"
                      x2="0"
                      y2="145.73"
                      stroke="transparent"
                      stroke-dasharray="0"
                      stroke-linecap="butt"
                    ></line>
                  </g>
                  <g id="SvgjsG1786" class="apexcharts-grid-borders">
                    <line
                      id="SvgjsLine1795"
                      x1="0"
                      y1="0"
                      x2="440.390625"
                      y2="0"
                      stroke="#dddddd"
                      stroke-dasharray="5"
                      stroke-linecap="butt"
                      class="apexcharts-gridline"
                    ></line>
                    <line
                      id="SvgjsLine1800"
                      x1="0"
                      y1="145.73"
                      x2="440.390625"
                      y2="145.73"
                      stroke="#dddddd"
                      stroke-dasharray="5"
                      stroke-linecap="butt"
                      class="apexcharts-gridline"
                    ></line>
                  </g>
                  <g
                    id="SvgjsG1764"
                    class="apexcharts-bar-series apexcharts-plot-series"
                  >
                    <g
                      id="SvgjsG1765"
                      class="apexcharts-series"
                      rel="1"
                      seriesName="Views"
                      data:realIndex="0"
                    >
                      <path
                        id="SvgjsPath1770"
                        d="M 26.423437500000002 140.731 L 26.423437500000002 5.001 C 26.423437500000002 2.5010000000000003 28.923437500000002 0.001 31.423437500000002 0.001 L 31.489508928571432 0.001 C 33.98950892857143 0.001 36.48950892857143 2.501 36.48950892857143 5.001 L 36.48950892857143 140.731 C 36.48950892857143 143.231 33.98950892857143 145.731 31.489508928571432 145.731 L 31.423437500000002 145.731 C 28.923437500000002 145.731 26.423437500000002 143.231 26.423437500000002 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 26.423437500000002 140.731 L 26.423437500000002 5.001 C 26.423437500000002 2.5010000000000003 28.923437500000002 0.001 31.423437500000002 0.001 L 31.489508928571432 0.001 C 33.98950892857143 0.001 36.48950892857143 2.501 36.48950892857143 5.001 L 36.48950892857143 140.731 C 36.48950892857143 143.231 33.98950892857143 145.731 31.489508928571432 145.731 L 31.423437500000002 145.731 C 28.923437500000002 145.731 26.423437500000002 143.231 26.423437500000002 140.731 Z "
                        pathFrom="M 26.423437500000002 145.731 L 26.423437500000002 145.731 L 36.48950892857143 145.731 L 36.48950892857143 145.731 L 36.48950892857143 145.731 L 36.48950892857143 145.731 L 36.48950892857143 145.731 L 26.423437500000002 145.731 Z"
                        cy="0"
                        cx="89.33638392857144"
                        j="0"
                        val="50"
                        barHeight="145.73"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1772"
                        d="M 89.33638392857144 140.731 L 89.33638392857144 92.439 C 89.33638392857144 89.939 91.83638392857144 87.439 94.33638392857144 87.439 L 94.40245535714287 87.439 C 96.90245535714287 87.439 99.40245535714287 89.939 99.40245535714287 92.439 L 99.40245535714287 140.731 C 99.40245535714287 143.231 96.90245535714287 145.731 94.40245535714287 145.731 L 94.33638392857144 145.731 C 91.83638392857144 145.731 89.33638392857144 143.231 89.33638392857144 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 89.33638392857144 140.731 L 89.33638392857144 92.439 C 89.33638392857144 89.939 91.83638392857144 87.439 94.33638392857144 87.439 L 94.40245535714287 87.439 C 96.90245535714287 87.439 99.40245535714287 89.939 99.40245535714287 92.439 L 99.40245535714287 140.731 C 99.40245535714287 143.231 96.90245535714287 145.731 94.40245535714287 145.731 L 94.33638392857144 145.731 C 91.83638392857144 145.731 89.33638392857144 143.231 89.33638392857144 140.731 Z "
                        pathFrom="M 89.33638392857144 145.731 L 89.33638392857144 145.731 L 99.40245535714287 145.731 L 99.40245535714287 145.731 L 99.40245535714287 145.731 L 99.40245535714287 145.731 L 99.40245535714287 145.731 L 89.33638392857144 145.731 Z"
                        cy="87.43799999999999"
                        cx="152.24933035714287"
                        j="1"
                        val="20"
                        barHeight="58.291999999999994"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1774"
                        d="M 152.24933035714287 140.731 L 152.24933035714287 121.585 C 152.24933035714287 119.085 154.74933035714287 116.585 157.24933035714287 116.585 L 157.3154017857143 116.585 C 159.8154017857143 116.585 162.3154017857143 119.085 162.3154017857143 121.585 L 162.3154017857143 140.731 C 162.3154017857143 143.231 159.8154017857143 145.731 157.3154017857143 145.731 L 157.24933035714287 145.731 C 154.74933035714287 145.731 152.24933035714287 143.231 152.24933035714287 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 152.24933035714287 140.731 L 152.24933035714287 121.585 C 152.24933035714287 119.085 154.74933035714287 116.585 157.24933035714287 116.585 L 157.3154017857143 116.585 C 159.8154017857143 116.585 162.3154017857143 119.085 162.3154017857143 121.585 L 162.3154017857143 140.731 C 162.3154017857143 143.231 159.8154017857143 145.731 157.3154017857143 145.731 L 157.24933035714287 145.731 C 154.74933035714287 145.731 152.24933035714287 143.231 152.24933035714287 140.731 Z "
                        pathFrom="M 152.24933035714287 145.731 L 152.24933035714287 145.731 L 162.3154017857143 145.731 L 162.3154017857143 145.731 L 162.3154017857143 145.731 L 162.3154017857143 145.731 L 162.3154017857143 145.731 L 152.24933035714287 145.731 Z"
                        cy="116.58399999999999"
                        cx="215.1622767857143"
                        j="2"
                        val="10"
                        barHeight="29.145999999999997"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1776"
                        d="M 215.1622767857143 140.731 L 215.1622767857143 86.6098 C 215.1622767857143 84.1098 217.6622767857143 81.6098 220.1622767857143 81.6098 L 220.22834821428575 81.6098 C 222.72834821428575 81.6098 225.22834821428575 84.1098 225.22834821428575 86.6098 L 225.22834821428575 140.731 C 225.22834821428575 143.231 222.72834821428575 145.731 220.22834821428575 145.731 L 220.1622767857143 145.731 C 217.6622767857143 145.731 215.1622767857143 143.231 215.1622767857143 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 215.1622767857143 140.731 L 215.1622767857143 86.6098 C 215.1622767857143 84.1098 217.6622767857143 81.6098 220.1622767857143 81.6098 L 220.22834821428575 81.6098 C 222.72834821428575 81.6098 225.22834821428575 84.1098 225.22834821428575 86.6098 L 225.22834821428575 140.731 C 225.22834821428575 143.231 222.72834821428575 145.731 220.22834821428575 145.731 L 220.1622767857143 145.731 C 217.6622767857143 145.731 215.1622767857143 143.231 215.1622767857143 140.731 Z "
                        pathFrom="M 215.1622767857143 145.731 L 215.1622767857143 145.731 L 225.22834821428575 145.731 L 225.22834821428575 145.731 L 225.22834821428575 145.731 L 225.22834821428575 145.731 L 225.22834821428575 145.731 L 215.1622767857143 145.731 Z"
                        cy="81.6088"
                        cx="278.07522321428576"
                        j="3"
                        val="22"
                        barHeight="64.12119999999999"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1778"
                        d="M 278.07522321428576 140.731 L 278.07522321428576 5.001 C 278.07522321428576 2.5010000000000003 280.57522321428576 0.001 283.07522321428576 0.001 L 283.1412946428572 0.001 C 285.6412946428572 0.001 288.1412946428572 2.501 288.1412946428572 5.001 L 288.1412946428572 140.731 C 288.1412946428572 143.231 285.6412946428572 145.731 283.1412946428572 145.731 L 283.07522321428576 145.731 C 280.57522321428576 145.731 278.07522321428576 143.231 278.07522321428576 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 278.07522321428576 140.731 L 278.07522321428576 5.001 C 278.07522321428576 2.5010000000000003 280.57522321428576 0.001 283.07522321428576 0.001 L 283.1412946428572 0.001 C 285.6412946428572 0.001 288.1412946428572 2.501 288.1412946428572 5.001 L 288.1412946428572 140.731 C 288.1412946428572 143.231 285.6412946428572 145.731 283.1412946428572 145.731 L 283.07522321428576 145.731 C 280.57522321428576 145.731 278.07522321428576 143.231 278.07522321428576 140.731 Z "
                        pathFrom="M 278.07522321428576 145.731 L 278.07522321428576 145.731 L 288.1412946428572 145.731 L 288.1412946428572 145.731 L 288.1412946428572 145.731 L 288.1412946428572 145.731 L 288.1412946428572 145.731 L 278.07522321428576 145.731 Z"
                        cy="0"
                        cx="340.9881696428572"
                        j="4"
                        val="50"
                        barHeight="145.73"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1780"
                        d="M 340.9881696428572 140.731 L 340.9881696428572 121.585 C 340.9881696428572 119.085 343.4881696428572 116.585 345.9881696428572 116.585 L 346.05424107142863 116.585 C 348.55424107142863 116.585 351.05424107142863 119.085 351.05424107142863 121.585 L 351.05424107142863 140.731 C 351.05424107142863 143.231 348.55424107142863 145.731 346.05424107142863 145.731 L 345.9881696428572 145.731 C 343.4881696428572 145.731 340.9881696428572 143.231 340.9881696428572 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 340.9881696428572 140.731 L 340.9881696428572 121.585 C 340.9881696428572 119.085 343.4881696428572 116.585 345.9881696428572 116.585 L 346.05424107142863 116.585 C 348.55424107142863 116.585 351.05424107142863 119.085 351.05424107142863 121.585 L 351.05424107142863 140.731 C 351.05424107142863 143.231 348.55424107142863 145.731 346.05424107142863 145.731 L 345.9881696428572 145.731 C 343.4881696428572 145.731 340.9881696428572 143.231 340.9881696428572 140.731 Z "
                        pathFrom="M 340.9881696428572 145.731 L 340.9881696428572 145.731 L 351.05424107142863 145.731 L 351.05424107142863 145.731 L 351.05424107142863 145.731 L 351.05424107142863 145.731 L 351.05424107142863 145.731 L 340.9881696428572 145.731 Z"
                        cy="116.58399999999999"
                        cx="403.90111607142865"
                        j="5"
                        val="10"
                        barHeight="29.145999999999997"
                        barWidth="10.066071428571428"
                      ></path>
                      <path
                        id="SvgjsPath1782"
                        d="M 403.90111607142865 140.731 L 403.90111607142865 34.147000000000006 C 403.90111607142865 31.647000000000006 406.40111607142865 29.147000000000002 408.90111607142865 29.147000000000002 L 408.9671875000001 29.147000000000002 C 411.4671875000001 29.147000000000002 413.9671875000001 31.647000000000006 413.9671875000001 34.147000000000006 L 413.9671875000001 140.731 C 413.9671875000001 143.231 411.4671875000001 145.731 408.9671875000001 145.731 L 408.90111607142865 145.731 C 406.40111607142865 145.731 403.90111607142865 143.231 403.90111607142865 140.731 Z "
                        fill="rgba(56,142,60,0.8)"
                        fill-opacity="1"
                        stroke-opacity="1"
                        stroke-linecap="round"
                        stroke-width="0"
                        stroke-dasharray="0"
                        class="apexcharts-bar-area"
                        index="0"
                        clip-path="url(#gridRectMaskodd6q2q4g)"
                        pathTo="M 403.90111607142865 140.731 L 403.90111607142865 34.147000000000006 C 403.90111607142865 31.647000000000006 406.40111607142865 29.147000000000002 408.90111607142865 29.147000000000002 L 408.9671875000001 29.147000000000002 C 411.4671875000001 29.147000000000002 413.9671875000001 31.647000000000006 413.9671875000001 34.147000000000006 L 413.9671875000001 140.731 C 413.9671875000001 143.231 411.4671875000001 145.731 408.9671875000001 145.731 L 408.90111607142865 145.731 C 406.40111607142865 145.731 403.90111607142865 143.231 403.90111607142865 140.731 Z "
                        pathFrom="M 403.90111607142865 145.731 L 403.90111607142865 145.731 L 413.9671875000001 145.731 L 413.9671875000001 145.731 L 413.9671875000001 145.731 L 413.9671875000001 145.731 L 413.9671875000001 145.731 L 403.90111607142865 145.731 Z"
                        cy="29.146"
                        cx="466.8140625000001"
                        j="6"
                        val="40"
                        barHeight="116.58399999999999"
                        barWidth="10.066071428571428"
                      ></path>
                      <g id="SvgjsG1767" class="apexcharts-bar-goals-markers">
                        <g
                          id="SvgjsG1769"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1771"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1773"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1775"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1777"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1779"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                        <g
                          id="SvgjsG1781"
                          className="apexcharts-bar-goals-groups"
                          class="apexcharts-hidden-element-shown"
                          clip-path="url(#gridRectMarkerMaskodd6q2q4g)"
                        ></g>
                      </g>
                      <g
                        id="SvgjsG1768"
                        class="apexcharts-bar-shadows apexcharts-hidden-element-shown"
                      ></g>
                    </g>
                    <g
                      id="SvgjsG1766"
                      class="apexcharts-datalabels apexcharts-hidden-element-shown"
                      data:realIndex="0"
                    ></g>
                  </g>
                  <line
                    id="SvgjsLine1803"
                    x1="0"
                    y1="0"
                    x2="440.390625"
                    y2="0"
                    stroke="#b6b6b6"
                    stroke-dasharray="0"
                    stroke-width="1"
                    stroke-linecap="butt"
                    class="apexcharts-ycrosshairs"
                  ></line>
                  <line
                    id="SvgjsLine1804"
                    x1="0"
                    y1="0"
                    x2="440.390625"
                    y2="0"
                    stroke-dasharray="0"
                    stroke-width="0"
                    stroke-linecap="butt"
                    class="apexcharts-ycrosshairs-hidden"
                  ></line>
                  <g
                    id="SvgjsG1805"
                    class="apexcharts-xaxis"
                    transform="translate(0, 0)"
                  >
                    <g
                      id="SvgjsG1806"
                      class="apexcharts-xaxis-texts-g"
                      transform="translate(0, -4)"
                    >
                      <text
                        id="SvgjsText1808"
                        font-family="inherit"
                        x="31.456473214285715"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1809">M</tspan>
                        <title>M</title>
                      </text>
                      <text
                        id="SvgjsText1811"
                        font-family="inherit"
                        x="94.36941964285714"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1812">T</tspan>
                        <title>T</title>
                      </text>
                      <text
                        id="SvgjsText1814"
                        font-family="inherit"
                        x="157.28236607142856"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1815">W</tspan>
                        <title>W</title>
                      </text>
                      <text
                        id="SvgjsText1817"
                        font-family="inherit"
                        x="220.1953125"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1818">T</tspan>
                        <title>T</title>
                      </text>
                      <text
                        id="SvgjsText1820"
                        font-family="inherit"
                        x="283.10825892857144"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1821">F</tspan>
                        <title>F</title>
                      </text>
                      <text
                        id="SvgjsText1823"
                        font-family="inherit"
                        x="346.0212053571429"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1824">S</tspan>
                        <title>S</title>
                      </text>
                      <text
                        id="SvgjsText1826"
                        font-family="inherit"
                        x="408.93415178571433"
                        y="174.73"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-size="13px"
                        font-weight="300"
                        fill="#37474f"
                        class="apexcharts-text apexcharts-xaxis-label"
                        style="font-family: inherit"
                      >
                        <tspan id="SvgjsTspan1827">S</tspan>
                        <title>S</title>
                      </text>
                    </g>
                  </g>
                  <g id="SvgjsG1848" class="apexcharts-yaxis-annotations"></g>
                  <g id="SvgjsG1849" class="apexcharts-xaxis-annotations"></g>
                  <g id="SvgjsG1850" class="apexcharts-point-annotations"></g>
                </g>
              </svg>
              <div class="apexcharts-tooltip apexcharts-theme-dark">
                <div
                  class="apexcharts-tooltip-title"
                  style="
                    font-family: Helvetica, Arial, sans-serif;
                    font-size: 12px;
                  "
                ></div>
                <div class="apexcharts-tooltip-series-group" style="order: 1">
                  <span class="apexcharts-tooltip-marker"></span>
                  <div
                    class="apexcharts-tooltip-text"
                    style="
                      font-family: Helvetica, Arial, sans-serif;
                      font-size: 12px;
                    "
                  >
                    <div class="apexcharts-tooltip-y-group">
                      <span class="apexcharts-tooltip-text-y-label"></span
                      ><span class="apexcharts-tooltip-text-y-value"></span>
                    </div>
                    <div class="apexcharts-tooltip-goals-group">
                      <span class="apexcharts-tooltip-text-goals-label"></span
                      ><span class="apexcharts-tooltip-text-goals-value"></span>
                    </div>
                    <div class="apexcharts-tooltip-z-group">
                      <span class="apexcharts-tooltip-text-z-label"></span
                      ><span class="apexcharts-tooltip-text-z-value"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-dark"
              >
                <div class="apexcharts-yaxistooltip-text"></div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="p-6 px-6 pt-0 text-end">
          <p
            class="block antialiased tracking-normal font-sans text-base font-semibold leading-relaxed text-blue-gray-900"
          >
            Total
          </p>
          <h6
            class="block antialiased font-sans text-sm leading-normal font-normal text-blue-gray-600"
          >
            1565
          </h6>
        </div> -->
        <div class="p-6 border-t border-blue-gray-50 px-6 py-5">
          <div class="flex justify-center">
            <p
            class="block antialiased tracking-normal font-sans text-xl  leading-relaxed text-blue-gray-900 mr-4"
          >
            Total -
          </p>
          <h6
            class="block antialiased font-sans text-xl leading-normal font-bold text-primary"
          >
            {{pichartDataTotal}}
            </h6>
          </div>
          <!-- <p
            class="antialiased font-sans text-sm leading-normal flex items-center font-normal text-blue-gray-600"
          > -->
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
              stroke-width="2"
              class="h-4 w-4 text-blue-gray-400"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                clip-rule="evenodd"
              ></path></svg>&nbsp; -->


        </div>
      </div>


        <!-- <div>-----</div> -->

      <!-- <div
        class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 border border-blue-gray-100 shadow-sm"
      >

        <div class="p-6 px-6 pt-0">
          <h6
            class="block antialiased tracking-normal font-sans text-base font-semibold leading-relaxed text-blue-gray-900"
          >
            Cards in Progress
          </h6>
          <p
            class="block antialiased font-sans text-sm leading-normal font-normal text-blue-gray-600"
          >
            15% increase in today sales
          </p>
        </div>
        <div class="p-6 border-t border-blue-gray-50 px-6 py-5">
          <p
            class="antialiased font-sans text-sm leading-normal flex items-center font-normal text-blue-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
              stroke-width="2"
              class="h-4 w-4 text-blue-gray-400"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                clip-rule="evenodd"
              ></path></svg>&nbsp;updated 4 min ago
          </p>
        </div>

      </div> -->

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">

        <div class="flex justify-between items-center">
          <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">
            Re-Pin Summary
          </h2>
        </div>

        <div class="space-y-4">
          @if(dashboardData?.cardRepinCounts){
            @for(statusCount of dashboardData.cardRepinCounts; track $index){
              <div class="flex justify-between mb-1">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ formatStatus(statusCount.status) }}</span>
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ statusCount.count }}</span>
              </div>
              <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div class="h-2.5 rounded-full" [ngClass]="getStatusCountColor(statusCount.status)" [style.width.%]="getStatusCountPercentage(statusCount.count)"></div>
              </div>
            }
          }
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <div class="flex justify-between items-center">
          <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">
            Card Overview
          </h2>
          <div class="p-4 text-right">
            <!--<p
              class="block antialiased font-sans text-md leading-normal font-normal text-blue-gray-600"
            >
             Card Entry
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"
            >
              {{getTotalCardEntry() }}
            </h4>-->
          </div>

        </div>

        <div class="space-y-4">
          @if(dashboardData?.cardStatusCounts){
            @for(statusCount of dashboardData.cardStatusCounts; track $index){
              <div class="flex justify-between mb-1">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ formatStatus(statusCount.status) }}</span>
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ statusCount.count }}</span>
              </div>
              <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div class="h-2.5 rounded-full" [ngClass]="getStatusCountColor(statusCount.status)" [style.width.%]="getStatusCountPercentage(statusCount.count)"></div>
              </div>
            }
          }


        </div>
      </div>



    </div>


    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <!-- Charts and Progress -->
      <div
        class="col-span-2 bg-white dark:bg-gray-800 rounded-lg shadow-md p-6"
      >
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">
          Card Status <p-chip label="{{year}}"/>
        </h2>
        <p-chart type="line" [data]="lineChartData" [options]="lineChartOptions" height="300px"/>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">

        <div class="flex justify-between ">

          <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">
            Notices
          </h2>

          <!--<h4 class="text-xl font-semibold  dark:text-white mb-4 cursor-pointer hover:underline text-blue-500 hover:text-blue-600" (click)="handleNotice()">
            See All
          </h4>-->

        </div>

        <div class="overflow-x-auto">

          <div class="card">

            <p-table #dt1 [value]="dashboardNoticeData" dataKey="id" [paginator]="true" [rows]="pageSize"
                     [lazy]="true"
                     [showCurrentPageReport]="true"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                     (onPage)="handleDataOnPageChange($event)"
                      (onLazyLoad)="handleLoadData($event)" [loading]="loading"
                     [resizableColumns]="true"
                     [totalRecords]="totalRecords">
              <ng-template pTemplate="header">
                <tr>
                  <th>S.N.</th>
                  <th pSortableColumn="title">Title
                    <p-sortIcon field="title"></p-sortIcon>
                  </th>
                  <th pSortableColumn="createdAt">Date
                    <p-sortIcon field="createdAt"></p-sortIcon>
                  </th>
                  <th scope="col" class="fixed-action" pResizableColumn>
                    <div class="flex justify-content-between align-items-center">
                      Action
                    </div>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-notice let-i="rowIndex" class="relative">
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ notice.title }} @if(!notice.isRead) {
                    <strong class="text-red-500 text-sm cursor-pointer">(New)</strong>
                  }</td>
                  <td>{{ notice.createdAt | date:'mediumDate'}}</td>
                  <td class="text-center fixed-action bg-white">
                    <div class="flex">
                      @if(notice.isRead) {
                        <p-button icon="pi pi-eye" title="View Notice" (click)="openDialog(notice)" [rounded]="true" [text]="true" />
                      } @else{
                          <p-button icon="pi pi-check-circle" title="Mark as Read" (click)="markAsRead(notice)" [rounded]="true"
                                  [text]="true" />
                      }
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="6">No data found.</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="loadingbody">
                <tr>
                  <td colspan="6">Loading data. Please wait.</td>
                </tr>
              </ng-template>
            </p-table>
           <!-- <p-table
              [value]="dashboardNoticeData"
              [paginator]="true"
              [rows]="5"
              [tableStyle]="{ 'min-width': '50rem' }"
              [rowsPerPageOptions]="[5, 10, 20]"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Type</th>
                  <th>Title</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-notice>
                <tr>
                  <td>Notice</td>
                  <td>{{ notice.title }}</td>
                  <td>{{ notice.createdAt }}</td>
                  <td>Mark as Read</td>
                </tr>
              </ng-template>
            </p-table>-->
          </div>
          <!--<table
            class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Type</th>
                <th scope="col" class="px-6 py-3">Title</th>
                <th scope="col" class="px-6 py-3">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">Notice</td>
                <td class="px-6 py-4">Created a new post</td>
                <td class="px-6 py-4">2081/07/20</td>
              </tr>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">Notice</td>
                <td class="px-6 py-4">Created a new post <strong class="text-red-500 text-sm cursor-pointer">(New)</strong></td>
                <td class="px-6 py-4">2081/07/20</td>
              </tr>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">Notice</td>
                <td class="px-6 py-4">Created a new post</td>
                <td class="px-6 py-4">2081/07/20</td>
              </tr>

              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">Notice</td>
                <td class="px-6 py-4">Created a new post <strong class="text-red-500 text-sm cursor-pointer">(New)</strong></td>
                <td class="px-6 py-4">2081/07/20</td>
              </tr>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <td class="px-6 py-4">Notice</td>
                <td class="px-6 py-4">Created a new post <strong class="text-red-500 text-sm cursor-pointer">(New)</strong></td>
                <td class="px-6 py-4">2081/07/20</td>
              </tr>

            </tbody>
          </table>-->
        </div>
      </div>

    </div>


  </div>
</app-page>
